import cx from 'classnames';
import { memo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { paginatedTexturesSelectors } from '../../../../../redux/slicers/textures/paginatedTexturesSlicer';
import { ProgressBar } from 'react-bootstrap';
import styles from './TextureUploadProgress.module.scss';

export const TextureUploadProgressContainer = (props) => {
  const isUploading = useSelector((state) =>
    paginatedTexturesSelectors.selectIsCardLoading(state, props.id)
  );

  if (!isUploading) return null;

  return <TextureUploadProgress {...props} />;
};

export const TextureUploadProgress = memo(({ id, className, height = 24 }) => {
  const hadProgressOnce = useRef(false);
  const uploadProgress = useSelector((state) =>
    paginatedTexturesSelectors.selectItemProgress(state, id)
  );

  let progress = hadProgressOnce.current ? 100 : 0; // if there was a progress shown before we assume that it was fully uploaded if not progress will be overwritten

  if (uploadProgress) {
    progress = Math.min(Math.floor((uploadProgress.loaded / uploadProgress.total) * 100), 100);
    hadProgressOnce.current = true;
  }

  // if (progress?.completed) return null;

  return (
    <div className={cx(styles.container, className)}>
      <div style={{ height: height, display: 'flex', alignItems: 'center' }}>
        <ProgressBar animated now={progress} variant='primary' style={{ height: 6, borderRadius: 8, width: 100 }} />
      </div>
    </div>
  );
});

export const BulkTextureUploadProgress = memo(({ id, className, height = 24, _progress = 0 }) => {
  const hadProgressNewOnce = useRef(false);
  const uploadProgressData = useSelector((state) =>
    paginatedTexturesSelectors.selectItemProgress(state, id)
  );

  let progress = hadProgressNewOnce.current ? 100 : 0; // if there was a progress shown before we assume that it was fully uploaded if not progress will be overwritten

  if (uploadProgressData) {
    progress = Math.min(Math.floor((uploadProgressData.loaded / uploadProgressData.total) * 100), 100);
    hadProgressNewOnce.current = true;
  }

  return (
    <div className={cx(styles.container, className)}>
      <div style={{ height: height, display: 'flex', alignItems: 'center' }}>
        <ProgressBar animated now={_progress || progress} variant='primary' style={{ height: 6, borderRadius: 8, width: 100 }} />
      </div>
    </div>
  );
});
